export const SellingConditionsFields = {
  treatmentQuantity: "treatment-quantity",
  treatmentProcessedQuantity: "treatment-processed-quantity",
  transportQuantity: "transport-quantity",
  treatmentQuantityUnit: "treatment-quantity-unit",
  treatmentProcessedQuantityUnit: "treatment-processed-quantity-unit",
  transportQuantityUnit: "transport-quantity-unit",
  transportType: "transport-type",
  product: "product",
  priceType: "price-type",
  currency: "currency",
  destinationAddress: "destination-address",
};

export const SolutionListFields = {
  equivalentTreatmentPrice: "equivalent-treatment-price",
  equivalentTransportPrice: "equivalent-transport-price",
  equivalentTransportTreatmentPrice: "equivalent-transport-treatment-price",
  internalComment: "internal-comment",
  allocation: "allocation",
};

export const SellingPriceFields = {
  treatmentPrice: "treatment-price",
  transportPrice: "transport-price",
  transportTreatmentPrice: "transport-treatment-price",
  treatmentExchangeRate: "study-treatment-exchange-rate",
  transportExchangeRate: "study-transport-exchange-rate",
  transportTreatmentExchangeRate: "study-transport-treatment-exchange-rate",
  sellingPriceDescription: "selling-price-description",
  sellingPriceAssumption: "selling-price-assumption",
  specificConditions: "specific-conditions",
  exchangeRate: "exchange-rate",
};

export const TreatmentServiceFields = {
  quantity: "treatment-quantity",
  unit: "treatment-unit",
  product: "treatment-product",
  transport: "treatment-transport",
  unitPrice: "treatment-unitPrice",
  totalPrice: "treatment-totalPrice",
  marginRate: "treatment-marginRate",
  comment: "treatment-comment",
};
